<div class="access-denied-wrapper">
  <div class="access-denied-header">
    {{ 'common.access_denied_header' | translate }}
  </div>
  <div class="access-denied-subtext">
    {{ 'common.access_denied_message' | translate }}
  </div>
  <div class="access-denied-buttons">
    <button class="btn btn-primary" (click)="goToMyTrack()">
      {{ 'common.go_to_mytrack' | translate }}
    </button>
    <button class="btn btn-secondary" (click)="logout()">
      {{ 'settings.logout' | translate }}
    </button>
  </div>
</div>
